// extracted by mini-css-extract-plugin
export default {"Header":"App_Header__Xhto5","Main":"App_Main__FJiSV","Footer":"App_Footer__1XCD8"};